import styled, { css } from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { TIconButtonProps } from './IconButton.types';

const VARIANT_STYLES = {
  plain: css`
    background-color: transparent;
    color: ${({ theme }) => theme.colors.textSecondary};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.surfaceHover};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  `,
  ghost: css`
    background-color: ${({ theme }) => theme.colors.backgroundTertiary};
    color: ${({ theme }) => theme.colors.textSecondary};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.surfaceHover};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  `,
  danger: css`
    background-color: ${({ theme }) => theme.colors.dangerSurface};
    color: ${({ theme }) => theme.colors.onDanger};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.dangerSurfaceHover};
    }
  `,
  overlay: css`
    background-color: ${({ theme }) => theme.colors.scrimMedium};
    color: ${({ theme }) => theme.colors.textPrimary};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.scrimStrong};
    }
  `,
};

export const StyledIconButton = styled.button.withConfig({ shouldForwardProp })<TIconButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ size = 'md' }) => (size === 'sm' ? 30 : 36)}px;
  height: ${({ size = 'md' }) => (size === 'sm' ? 30 : 36)}px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  ${({ variant = 'plain' }) => VARIANT_STYLES[variant]}

  ${({ isActive, theme }) =>
    isActive &&
    css`
      background-color: ${theme.colors.surfaceHover};
      color: ${theme.colors.textPrimary};
    `}

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;
